import $ from 'jquery';
import { IMap } from '../../../../interface';

const mapTemplate = require('./view/map.handlebars');
const BASE_SELECTOR: string = '[data-map]';

export class MapUI {
    public constructor(private $base: JQuery) {}

    public render(data: IMap) {
        this.$base.html(mapTemplate(data));
    }

    public data() {
        return JSON.parse(this.$base.attr('data-map'));
    }
}

export function createMapInstances(): MapUI[] {
    const $base = $(BASE_SELECTOR);
    const instances: MapUI[] = [];
    $base.each((index, el) => {
        instances.push(new MapUI($(el)));
    });

    return instances;
}
